import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Text } from "@fluentui/react-components";
import { Shield24Regular } from "@fluentui/react-icons";
import { Column, Row } from "../../common";
import { useUtilities } from "../../../utilities/useUtilities";
import { useTermsAndPoliciesService } from "../../../data/services/useTermsAndPoliciesService";
import Logo from "../../common/appLogo";

export enum TermsAndPoliciesEnum {
    termsOfService = 'Terms of Service',
    privacyPolicy = 'Privacy Policy',
    dpa = 'Data Processing Agreement'
}

export type TermsOfServiceDialogProps = {
    children?: JSX.Element;
    onAccept?: () => Promise<void>;
    onClose?: () => void;
    isStatic?: boolean;
    whichPolicy?: TermsAndPoliciesEnum;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}
export const TermsAndPoliciesDialog = (props: TermsOfServiceDialogProps) => {

    const { children, onAccept, onClose, isStatic = false, whichPolicy = TermsAndPoliciesEnum.termsOfService, open, onOpenChange } = props;

    //Hooks
    const utils = useUtilities();
    const { termsAndPolicies } = useTermsAndPoliciesService();

    let shownPolicy = termsAndPolicies?.termsOfService;
    if (whichPolicy == TermsAndPoliciesEnum.privacyPolicy) shownPolicy = termsAndPolicies?.privacyPolicy;
    else if (whichPolicy == TermsAndPoliciesEnum.dpa) shownPolicy = termsAndPolicies?.dataProcessingAgreement;

    //UI Events
    const onClickAccept = async (e: any) => {
        e.stopPropagation();
        if (!!onAccept) await onAccept();
    }
    const onClickClose = (e: any) => {
        e.stopPropagation();
        if (!!onClose) onClose();
    }


    const dialogSurface = (
        <DialogSurface>
            <DialogBody>
                <DialogTitle>
                    <Row gap='medium'>
                        <Column width='auto' vAlign='middle'>
                            <Shield24Regular />
                        </Column>
                        <Column>
                            {whichPolicy}
                        </Column>
                        <Column width='auto'>
                            <Logo />
                        </Column>
                    </Row>
                </DialogTitle>
                <DialogContent>
                    <Column scroll maxHeight='400px' padding='pr-3 py-3' gap='medium'>
                        <Column noGap>
                            <Text><Text weight='semibold'>Effective Date: </Text>{utils.date.formatDate(shownPolicy?.effectiveDate, undefined, true)}</Text>
                            <Text><Text weight='semibold'>Last Updated: </Text>{utils.date.formatDate(shownPolicy?.lastUpdated, undefined, true)}</Text>
                        </Column>
                        <Text>{shownPolicy?.intro}</Text>
                        {shownPolicy?.sections?.map((section) => (
                            <Column key={section.title} gap='small' padding={section.indent ? 'pl-3' : ''}>
                                <Text weight='semibold' size={400}>{section?.title}</Text>
                                <Text>{section?.content}</Text>
                            </Column>
                        ))}
                    </Column>
                </DialogContent>
                <DialogActions>
                    {!!onAccept && (
                        <DialogTrigger disableButtonEnhancement>
                            <Button
                                type="submit"
                                appearance="primary"
                                onClick={onClickAccept}
                                data-testid='login-tos-accept'
                            >
                                Accept
                            </Button>
                        </DialogTrigger>
                    )}
                    <DialogTrigger disableButtonEnhancement>
                        <Button
                            appearance="secondary"
                            onClick={onClickClose}
                            data-testid='login-tos-close'
                        >
                            Close
                        </Button>
                    </DialogTrigger>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    );

    return (
        <>
            {!isStatic ? (
                <Dialog open={open} onOpenChange={(_, data) => onOpenChange?.(data.open)}>
                    {!!children && (
                        <DialogTrigger disableButtonEnhancement>
                            {children}
                        </DialogTrigger>
                    )}
                    {dialogSurface}
                </Dialog>
            ) : (
                <>
                    {dialogSurface}
                </>
            )}
        </>
    );
}